export default class EyeSpreader {
  constructor(element) {
    window.imagePath = window.imagePath || '';
    this.path = window.imagePath || 'assets/images/';

    this.element = element;
    this.options = {
      widthMin: 150,
      widthMax: 400,
      animationMax: 2,
      animationMin: 0.8,
      duration: 10000,
      delay: 200,
    };

    this.init();
  }

  setOptions() {
    if ('delay' in this.element.dataset) {
      this.options.delay = this.element.dataset.delay;
    }

    if ('duration' in this.element.dataset) {
      this.options.duration = this.element.dataset.duration;
    }

    if ('widthMin' in this.element.dataset) {
      this.options.widthMin = this.element.dataset.widthMin;
    }

    if ('widthMax' in this.element.dataset) {
      this.options.widthMax = this.element.dataset.widthMax;
    }
  }

  init() {
    this.setOptions();

    this.spawnEye();
  }

  spawnEye() {
    const newEye = document.createElement('img');
    newEye.setAttribute('src', this.path + 'eyes/eye_gael-1.png');
    newEye.classList.add('eye');

    //   Randomize
    newEye.style.width = `${Math.random() * (this.options.widthMax - this.options.widthMin) + this.options.widthMin}px`;
    newEye.style.top = `${Math.random() * 100}%`;
    newEye.style.left = `${Math.random() * 100}%`;
    newEye.style.animationanimation = `${Math.random() * (this.options.animationMax - this.options.animationMin) + this.options.animationMin}s`;

    this.element.appendChild(newEye);

    setTimeout(() => newEye.classList.add('placed'), 10);
    setTimeout(() => newEye.classList.remove('placed'), this.options.duration);
    setTimeout(() => newEye.remove(), this.options.duration + 800);
    setTimeout(this.spawnEye.bind(this), this.options.delay);
  }
}
